import dayjs from "dayjs"

type FormatDateProps = {
  children?: string
  format?: string
}

export default function FormatDate({ children, format = "DD/MM/YYYY" }: FormatDateProps) {
  if(!children) return null
  const dateFormatted = dayjs(children).format(format)
  return dateFormatted
}
